import {BASE_URL} from '@/utils/config';

export const bookTicket = async (axiosInstance, ticketDetails) => {
	try {
		const response = await axiosInstance.post(`${BASE_URL}/event/book-ticket`, ticketDetails);
		console.log("(eventApi.js.js | bookTicket) Book Ticket Response: ", response);

		return response.data;
	} catch (error) {
		console.log("(eventApi.js.js | bookTicket) Error while Booking Ticket:", error);
	}
}

export const getAllActiveEvents = async (axiosInstance) => {
	try {
		const response = await axiosInstance.get(`${BASE_URL}/event/get-active`);
		console.log("(eventApi.js.js | getAllActiveEvents) Fetch Events Page Base Data Response: ", response);

		return response.data;
	} catch (error) {
		console.log("(eventApi.js.js | getAllActiveEvents) Error while fetching all events:", error);
	}
}

export const fetchAllPastEventsWithMemories = async (axiosInstance) => {
	try {
		const response = await axiosInstance.get(`${BASE_URL}/event/get-all-past-events-with-memories`);
		console.log("(eventApi.js.js | fetchAllPastEventsWithMemories) Fetch Past Events with Memories Data Response: ", response);

		return response.data;
	} catch (error) {
		console.log("(eventApi.js.js | fetchAllPastEventsWithMemories) Error while fetching all events:", error);
	}
}
